<script>
    import { onMount } from 'svelte';
    import { fetchAllCourseTypeCourses } from '/public/services/courses.js';   
    import CoursePayload from './CoursePayload.svelte';
    import { navigateTo } from 'svelte-router-spa';
    import { slide } from 'svelte/transition';
    
    export let course_type_id;
    
    let course_type = null;
    let loading = true;
    let courses = null;
    let show_desc = false;
    
    function loadCourses() {
        fetchAllCourseTypeCourses(course_type_id).then(res => {
            if (res.success) {                
                course_type = res.data.course_type;
                courses = res.data.courses;

                loading = false;
            } else {
                navigateTo('/home');
            }
        });
    }    

    onMount(() => {
        loadCourses();
    });
</script>
{#if loading === true}

    <div class='text-center'>
        <h4>
            <span class='ajax-ball-loader'></span> Looking for Courses....
        </h4>
    </div>

{:else}   

    <div class='card mb-3'>
        <div class='card-header'>
            { course_type.name }
        </div>
        <div class='card-body'>
            <div class='clearfix mb-3'>

                {#if show_desc === false}

                    <button type='button' class='btn btn-sm btn-outline-primary float-end ms-2' on:click={() => show_desc = true}>
                        <span class='fas fa-chevron-down'></span> Show Course Description
                    </button>

                {:else}

                    <button type='button' class='btn btn-sm btn-outline-primary float-end ms-2' on:click={() => show_desc = false}>
                        <span class='fas fa-chevron-up'></span> Hide Course Description
                    </button>

                {/if}

                <button type='button' class='btn btn-outline-info me-2 btn-sm d-lg-none' disabled>
                    ${ course_type.price }
                </button>

                <h4 class='d-none d-lg-block'>
                    ${ course_type.price }
                </h4>
            </div>            

            {#if show_desc === true}

                <section in:slide out:slide>

                    {@html course_type.description}

                </section>

            {/if}

        </div>
    </div>

    <hr/>

    <CoursePayload
        courses={courses}
    />

{/if}